export function kitchenClientHeaders(): Record<string, string> {
  const headers: Record<string, string> = {};
  try {
    const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    if (timezone) headers['X-Kitchen-Timezone'] = timezone;
  } catch {
    // The backend deliberately falls back to UTC when browser metadata is unavailable.
  }
  if (navigator.language) headers['X-Kitchen-Locale'] = navigator.language;
  return headers;
}
